<template>
  <v-container fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">组件管理</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">组件列表</v-subheader>
            <v-spacer></v-spacer>
            <v-btn outlined  color="primary" @click.stop="add">
              <v-icon left>mdi-plus</v-icon>新增
            </v-btn>
          </v-card-actions>
          <!-- <p>
            {{ platTypeList }}
          </p> -->
          <v-card-text>
            <div class="table-filter">
              <div class="box">
                <span class="label">组件Code</span>
                <v-text-field v-model="filterForm.comCode" outlined placeholder="请输入" solo></v-text-field>
              </div>
              <div class="box">
                <span class="label">名称</span>
                <v-text-field v-model="filterForm.comName" outlined placeholder="请输入" solo></v-text-field>
              </div>
              <div class="box">
                <span class="label">平台类型</span>
                <v-select v-model="filterForm.platType" outlined :items="platTypeList" placeholder="请选择" solo
                  item-text="name"
                  item-value="code"
                  ></v-select>
                </div>
                <v-btn @click.stop="reset" class="margin-left-2x">重 置</v-btn>
                <v-btn color="primary" @click.stop="query" class="margin-left-2x">查 询</v-btn>
              </div>
            <v-data-table
              :headers="headers"
              :items="list"
              :items-per-page="10"
              class="elevation-1"
            >
            <template v-slot:[`item.comType`]="{ item }">
              <!-- <span>{{item.comType}} {{typeList}}</span> -->
              <!-- mdi-cellphone-iphone -->
              <!-- mdi-monitor -->
              <span :class="colorText[item.comType - 1]" v-if="item && typeList.length > 0"> {{typeList.find(e => e.id === item.comType).name}} </span>
            </template>
            <template v-slot:[`item.userType`]="{ item }">
              <!-- <span> {{item.userType}}</span> -->
              <span v-if="item.userType">
                <span v-if="item.userType === 'common'">
                  <span v-for="(subItem, i) in userTypeList" :key="i">
                    {{ subItem.name }}
                    <span v-if="i + 1 < userTypeList.length">&nbsp;/&nbsp;</span>
                  </span>
                </span>
                <span v-else>
                  {{userTypeList.find(e => e.label === item.userType).name}}
                </span>
              </span>
            </template>
            <template v-slot:[`item.platType`]="{ item }">
              <!-- <span>{{item.platType}} {{platTypeList}}</span> -->
              <span v-if="item.platType && platTypeList.length > 0"> {{platTypeList.find(e => e.code === item.platType).name}} </span>
            </template>
            <template v-slot:[`item.comIconUrl`]="{ item }">
              <img v-if="item.comIconUrl" class="table-img" width="60" :src="imgSrcTimestamp(item.comIconUrl)" :alt="item.comIcon">
            </template>
              <!-- <template v-slot:[`item.isPc`]="{ item }">
                <span v-if="item.isPc" class="mdi mdi-check mdi-24px text-success"></span>
              </template>
              <template v-slot:[`item.isH5`]="{ item }">
                <span v-if="item.isH5" class="mdi mdi-check mdi-24px text-success"></span>
              </template>
              <template v-slot:[`item.isWxMini`]="{ item }">
                <span v-if="item.isWxMini" class="mdi mdi-check mdi-24px text-success"></span>
              </template> -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn class="ma-2 white--text" small  color="success" @click="clickAction(item, 'detail')">查看</v-btn>
                <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'edit')">编辑</v-btn>
                <v-btn class="ma-2 white--text" small color="error" @click="clickAction(item, 'delete')">删除</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">删除组件</span>
        </v-card-title>
        <v-card-text class="pb-0">
          确定要删除组件“{{this.currentItem.comName}}”（comCode：{{this.currentItem.comCode}}）？<br>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="deleteItem" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { imgSrcTimestamp } from '@/plugins/utils'
import { handleResponse } from '@/plugins/errorHandler'
import { mapState } from 'vuex'
// import { params } from 'vee-validate/dist/types/rules/alpha'
const request = buildAxios()
export default {
  name: 'AppInfo',
  components: {
  },
  data () {
    return {
      colorText: ['indigo--text', 'deep-orange--text', 'teal--text'],
      headers: [
        // { text: 'id', value: 'id' },
        { text: '组件Code', value: 'comCode' },
        { text: '名称', value: 'comName' },
        // { text: '英文名称', value: 'nameEn' },
        { text: '组件类型', value: 'comType' },
        { text: '用户类型', value: 'userType' },
        { text: '平台类型', value: 'platType' },
        // { text: '状态', value: 'status' },
        { text: '组件图示', value: 'comIconUrl' },
        // { text: 'h5', value: 'isH5' },
        // { text: '小程序', value: 'isWxMini' },
        { text: '操作', value: 'actions' }
      ],
      // desserts: [],
      list: [],
      deleteDialog: false,
      currentItem: {},
      typeList: [],
      filterForm: {
        comCode: '',
        comName: '',
        platType: ''
      }
    }
  },
  computed: {
    ...mapState(['userTypeList', 'platTypeList', 'componentTypeList'])
  },
  created () {
    this.getList()
    if (!this.componentTypeList) {
      this.getTypeList()
    } else {
      this.typeList = this.componentTypeList
    }
    // this.getTypeList()
  },
  methods: {
    imgSrcTimestamp,
    add () {
      console.log(11)
      this.$router.push({ name: 'componentAdd' })
    },
    // 组件列表
    getList (params) {
      let str = ''
      if (params) {
        // this.pagination.page = 1
        Object.keys(this.filterForm).map((key) => {
          if (this.filterForm[key]) {
            str = str + '&' + key + '=' + this.filterForm[key]
          }
        })
      }

      request.get('baseComponent/list' + (str ? '?' + str : ''))
        .then(res => {
          // this.desserts = []
          const data = res.data.data
          this.list = data
          // console.log(data)
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // 组件类型列表
    getTypeList () {
      // /cloud-api/baseComponentTypeInfo/add
      request.get('baseComponentTypeInfo/list')
        .then(res => {
          // this.desserts = []
          const data = res.data.data
          this.typeList = data
          this.$store.commit('setComponentType', data)
          console.log(data)
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    clickAction (item, type) {
      this.currentItem = item
      sessionStorage.setItem('componentDetail', JSON.stringify(item))
      if (type === 'detail') {
        this.$router.push({ name: 'componentDetail', query: { comCode: item.comCode } })
      } else if (type === 'edit') {
        this.$router.push({ name: 'componentAdd', query: { comCode: item.comCode } })
      } else if (type === 'delete') {
        this.deleteDialog = true
      }
    },
    deleteItem () {
      // const request = buildAxios()
      request.post('baseComponent/delete', { comCode: this.currentItem.comCode }).then(res => {
        this.deleteDialog = false
        this.getList()
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    },
    reset () {
      for (const key in this.filterForm) {
        this.filterForm[key] = ''
      }
      this.getList()
    },
    query () {
      console.log(this.filterForm)
      this.getList(this.filterForm)
    }
  },
  filters: {
  }
}
</script>
